import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SpecialtyService {

  constructor(private http: HttpClient) { }

  getQuery(queryParam: string): Observable<any> {
    return this.http.get(`${environment.api}/open/specialties/search?query=${queryParam}`);
  }

  getMainSpecialties(): Observable<any> {
    return this.http.get(`${environment.api}/open/specialtiesPrincipal`);
  }
}
